import { useApi } from "../api";
import { createAdminCrudApi } from "../createAdminCrudApi";
import { DECK_ADMIN_URL } from "./deckAdminUrl";
import { SearchGroovingTypesResponse, UpdateGroovingTypeBody } from "./types/groovingTypes";

export const useDeckGroovingTypesApi = () => {
  const crud = createAdminCrudApi<SearchGroovingTypesResponse, never, UpdateGroovingTypeBody>(
    useApi(),
    DECK_ADMIN_URL,
    "grooving_types",
  );

  return {
    useDeckGroovingTypes: crud.useSearch,
    getDeckGroovingTypes: crud.search,
    updateDeckGroovingType: crud.update,
    generateUploadImageUrl: crud.generateUploadImageUrl,
    uploadImage: crud.uploadImage,
  };
};

export default useDeckGroovingTypesApi;
